import {theme, ThemeConfig} from 'antd';


// Light theme configuration
export const lightThemeConfig: ThemeConfig = {
    token: {
        motion: true,
        colorPrimary: "#1677FF",
        colorInfo: "#1677ff",
        colorPrimaryBg: "#e6f4ff",
        colorPrimaryBgHover: "#bae0ff",
        colorPrimaryBorder: "#91caff",
        colorPrimaryBorderHover: "#69b1ff",
        colorPrimaryHover: "#4096ff",
        colorPrimaryActive: "#0958d9",
        colorPrimaryTextHover: "#4096ff",
        colorPrimaryText: "#1677ff",
        colorPrimaryTextActive: "#0958d9",
        colorSuccess: "#52c41a",
        colorSuccessBg: "#f6ffed",
        colorSuccessBgHover: "#d9f7be",
        colorSuccessBorder: "#b7eb8f",
        colorSuccessBorderHover: "#95de64",
        colorSuccessHover: "#95de64",
        colorSuccessActive: "#389e0d",
        colorSuccessTextHover: "#73d13d",
        colorSuccessText: "#52c41a",
        colorSuccessTextActive: "#389e0d",
        colorWarning: "#faad14",
        colorWarningBg: "#fffbe6",
        colorWarningBgHover: "#fff1b8",
        colorWarningBorder: "#ffe58f",
        colorWarningBorderHover: "#ffd666",
        colorWarningHover: "#ffd666",
        colorWarningActive: "#d48806",
        colorWarningTextHover: "#ffc53d",
        colorWarningText: "#faad14",
        colorWarningTextActive: "#d48806",
        colorError: "#ff4d4f",
        colorInfoBg: "#e6f4ff",
        colorInfoBgHover: "#bae0ff",
        colorInfoBorder: "#91caff",
        colorInfoBorderHover: "#69b1ff",
        colorInfoHover: "#69b1ff",
        colorInfoActive: "#0958d9",
        colorInfoTextHover: "#4096ff",
        colorInfoText: "#1677ff",
        colorInfoTextActive: "#0958d9",
        colorLink: "#1677ff",
        colorLinkHover: "#69b1ff",
        colorLinkActive: "#0958d9",
        colorTextBase: "#000000",
        colorBgBase: "#ffffff",
        boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        boxShadowSecondary: "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        //font sizes,margin,line height etc.
        fontSize: 14,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSizeXL: 20,
        fontSizeHeading3: 24,
        fontSizeHeading5: 16,
        fontSizeHeading2: 30,
        fontSizeHeading1: 36,
        fontSizeHeading4: 20,
        lineHeight: 1.56,
        lineHeightSM: 1.66,
        lineHeightLG: 1.5,
        lineHeightHeading1: 1.21,
        lineHeightHeading2: 1.26,
        lineHeightHeading3: 1.33,
        lineHeightHeading4: 1.4,
        lineHeightHeading5: 1.5,
        sizeStep: 4,
        sizeUnit: 4,
        borderRadius: 6,
        marginXXS: 4,
        marginSM: 12,
        marginMD: 20,
        marginXL: 32,
        marginXS: 8,
        margin: 16,
        marginLG: 24,
        marginXXL: 32,
        paddingXXS: 4,
        paddingSM: 12,
        paddingMD: 20,
        paddingXL: 32,
        paddingXS: 8,
        padding: 16,
        paddingLG: 24,
        borderRadiusXS: 2,
        borderRadiusLG: 8,
        borderRadiusSM: 4,
    },
    // algorithm: theme.darkAlgorithm,
};

// Dark theme configuration
export const darkThemeConfig: ThemeConfig = {
    token: {
        motion: true,
        colorPrimary: "#1677ff",
        colorInfo: "#1677ff",
        colorSuccess: "#52c41a",
        colorPrimaryBg: "#111a2c",
        colorPrimaryBgHover: "#112545",
        colorPrimaryBorder: "#15325b",
        colorPrimaryBorderHover: "#15417e",
        colorPrimaryHover: "#3c89e8",
        colorPrimaryActive: "#1554ad",
        colorPrimaryTextHover: "#3c89e8",
        colorPrimaryText: "#1668dc",
        colorPrimaryTextActive: "#1554ad",
        colorSuccessBg: "#162312",
        colorSuccessBgHover: "#1d3712",
        colorSuccessBorder: "#274916",
        colorSuccessBorderHover: "#306317",
        colorSuccessHover: "#306317",
        colorSuccessActive: "#3c8618",
        colorSuccessTextHover: "#6abe39",
        colorSuccessText: "#49aa19",
        colorSuccessTextActive: "#3c8618",
        colorWarning: "#faad14",
        colorWarningBg: "#2b2111",
        colorWarningBgHover: "#443111",
        colorWarningBorder: "#594214",
        colorWarningBorderHover: "#7c5914",
        colorWarningHover: "#7c5914",
        colorWarningActive: "#aa7714",
        colorWarningTextHover: "#e8b339",
        colorWarningText: "#d89614",
        colorWarningTextActive: "#aa7714",
        colorError: "#ff4d4f",
        colorErrorBg: "#2c1618",
        colorErrorBgHover: "#451d1f",
        colorErrorBorder: "#5b2526",
        colorErrorBorderHover: "#7e2e2f",
        colorErrorHover: "#e86e6b",
        colorErrorActive: "#ad393a",
        colorErrorTextHover: "#e86e6b",
        colorErrorText: "#dc4446",
        colorErrorTextActive: "#ad393a",
        colorInfoBg: "#111a2c",
        colorInfoBgHover: "#112545",
        colorInfoBorder: "#15325b",
        colorInfoBorderHover: "#15417e",
        colorInfoHover: "#15417e",
        colorInfoActive: "#1554ad",
        colorInfoTextHover: "#3c89e8",
        colorInfoText: "#1668dc",
        colorInfoTextActive: "#1554ad",
        colorLink: "#1668dc",
        colorLinkHover: "#153a6e",
        colorLinkActive: "#154b96",
        colorTextBase: "#ffffff",
        colorBgBase: "#000000",
        boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        boxShadowSecondary: "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        //font sizes,margin,line height etc.
        fontSize: 14,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSizeXL: 20,
        fontSizeHeading3: 24,
        fontSizeHeading5: 16,
        fontSizeHeading2: 30,
        fontSizeHeading1: 36,
        fontSizeHeading4: 20,
        lineHeight: 1.56,
        lineHeightSM: 1.66,
        lineHeightLG: 1.5,
        lineHeightHeading1: 1.21,
        lineHeightHeading2: 1.26,
        lineHeightHeading3: 1.33,
        lineHeightHeading4: 1.4,
        lineHeightHeading5: 1.5,
        sizeStep: 4,
        sizeUnit: 4,
        borderRadius: 6,
        marginXXS: 4,
        marginSM: 12,
        marginMD: 20,
        marginXL: 32,
        marginXS: 8,
        margin: 16,
        marginLG: 24,
        marginXXL: 32,
        paddingXXS: 4,
        paddingSM: 12,
        paddingMD: 20,
        paddingXL: 32,
        paddingXS: 8,
        padding: 16,
        paddingLG: 24,
        borderRadiusXS: 2,
        borderRadiusLG: 8,
        borderRadiusSM: 4,
    },
    algorithm: theme.darkAlgorithm,
};

// Assign object to variable before exporting as module default
const themeConfigs = {
    lightThemeConfig,
    darkThemeConfig
};

export default themeConfigs;